import { useQuery, useQueryClient } from '@tanstack/vue-query';
import { defineStore } from 'pinia';
import { useUpdateStatusStore } from '../updateStatus';
import { useAuthStore } from '../auth';
import { computed, Ref } from 'vue';
import { IPaginationDTO, ISubmissionDTO, SubmissionDTO } from '@/dtos';
import { getAllSubmissionsAPI } from '@/services/admin';

export const useAdminSubmissionStore = defineStore('admin-submission', () => {
  const queryClient = useQueryClient();
  const statusStore = useUpdateStatusStore();
  const authStore = useAuthStore();

  const getAllSubmissions = (
    branchId: Ref<string>,
    yearId: Ref<string>,
    pagination: Ref<IPaginationDTO>,
  ) =>
    useQuery({
      queryKey: computed(() => ['submissions-all', branchId.value, yearId.value, pagination.value]),
      queryFn: async (): Promise<{ data: ISubmissionDTO[]; count: number }> => {
        const ret = await getAllSubmissionsAPI(branchId.value, yearId.value, pagination.value);
        const submissions = await Promise.all<ISubmissionDTO[]>(
          ret.data.map((submission) => new SubmissionDTO(submission)),
        );
        return { data: submissions, count: ret.count };
      },
      enabled: computed(() => authStore.isAdmin && !!branchId.value && !!yearId.value),
    });

  return {
    getAllSubmissions,
  };
});
